/* eslint arrow-body-style: 0 */
import View from './components/BroadcastView.vue';
import Edit from './components/BroadcastEdit.vue';
import Form from './components/BroadcastForm.vue';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/broadcasts'),
    name: 'broadcasts_index',
    roles: ['administrator', 'agent'],
    component: View,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/:templateName/edit'),
    name: 'broadcasts_edit',
    roles: ['administrator', 'agent'],
    component: Edit,
  },
  {
    path: frontendURL('accounts/:accountId/broadcasts/form'),
    name: 'broadcasts_create',
    roles: ['administrator', 'agent'],
    component: Form,
  },
];
